<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <h4>{{ 'pages.transport.detail-page.sender-recipient.headline' | translate }}</h4>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-6 border-lg-end">
        <h5>{{ 'pages.transport.detail-page.sender-recipient.sender' | translate }}</h5>

        <div class="col-12 row">
          <div class="col-12 col-md-6">
            @if (details().sender.name1) {
              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.sender-recipient.name' | translate"
                [data]="details().sender.name1"
                [isDataBold]="true"
              />
            }

            @if (details().sender.name2) {
              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.sender-recipient.name2' | translate"
                [data]="details().sender.name2"
                [isDataBold]="true"
              />
            }

            @if (details().sender.name3) {
              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.sender-recipient.name3' | translate"
                [data]="details().sender.name3"
                [isDataBold]="true"
              />
            }
          </div>
          <div class="col-12 col-md-6">
            <myarvato-address-field
              [label]="'pages.transport.detail-page.sender-recipient.address' | translate"
              [street]="details().sender.street"
              [city]="details().sender.zipCode + ' ' + details().sender.city"
              [countryCode]="details().sender.country"
            />
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 mt--16 mt-lg--0">
        <h5>{{ 'pages.transport.detail-page.sender-recipient.recipient' | translate }}</h5>

        <div class="row">
          <div class="col-12 col-md-6">
            @if (details().recipient.name1) {
              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.sender-recipient.name' | translate"
                [data]="details().recipient.name1"
                [isDataBold]="true"
              />
            }

            @if (details().recipient.name2) {
              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.sender-recipient.name2' | translate"
                [data]="details().recipient.name2"
                [isDataBold]="true"
              />
            }

            @if (details().recipient.name3) {
              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.sender-recipient.name3' | translate"
                [data]="details().recipient.name3"
                [isDataBold]="true"
              />
            }

            @if (details().recipient.emailAddress) {
              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.sender-recipient.emailAddress' | translate"
                [data]="details().recipient.emailAddress"
                [isDataBold]="true"
              />
            }

            @if (details().recipient.phoneNumber) {
              <myarvato-data-field
                styleClass="pb--8"
                [label]="'pages.transport.detail-page.sender-recipient.phoneNumber' | translate"
                [data]="details().recipient.phoneNumber"
                [isDataBold]="true"
              />
            }
          </div>
          <div class="col-12 col-md-6">
            <myarvato-address-field
              styleClass="pb--8"
              [label]="'pages.transport.detail-page.sender-recipient.address' | translate"
              [street]="details().recipient.street"
              [city]="details().recipient.zipCode + ' ' + details().recipient.city"
              [countryCode]="details().recipient.country"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
